import { ContentWithData } from "./ContentWithData";

export function createSafeContentWithData<Data extends Record<string, unknown>>() {
  return {
    Content: ContentWithData<Data>,
    // TODO restore `ComponentInputs extend Inputs` once `Input` type is exported from @builder.io/sdk-react
    // It has been removed to allow tsc to pass without the error:
    // error TS2742: The inferred type of 'createDefaultDataBindings' cannot be named without a reference to '../../../node_modules/@builder.io/sdk-react/types/types/input'. This is likely not portable. A type annotation is necessary.
    createDefaultDataBindings: <ComponentInputs,>(
      bindings: Record<keyof Omit<BuilderComponentProps<ComponentInputs>, "builderBlock" | "attributes">, keyof Data>
    ) =>
      Object.entries(bindings).reduce((result, [key, value]) => {
        result[`component.options.${key}`] = `state.${value}`;
        return result;
      }, {} as Bindings),
  } as const;
}

type Bindings = Record<`component.options.${string}`, `state.${string}`>;
